<script lang="ts">
  import IndustryTree from '$lib/components/IndustryTree.svelte';
  import { dataSelectionSearch } from '$lib/stores/dataSelectionSearch';

  /**
   * The industry picker, as a popup.
   *
   * It was its own implementation of the same tree the guided search screen
   * has — the same grouping, search, expand-collapse and select-all, written
   * out twice and already drifting apart. The tree is IndustryTree now; what
   * is left here is where the search text comes from.
   *
   * The search box lives in the modal's own bar and publishes to
   * `dataSelectionSearch`, so the tree does not draw one.
   *
   * Categories start open: this is a wide dialog whose only job is choosing
   * industries, where the guided screen shows the tree in a column beside
   * everything else in a step.
   */
</script>

<div class="p-4">
  <IndustryTree query={$dataSelectionSearch} showSearch={false} expandAll={true} />
</div>
